export default __webpack_public_path__ + "static/media/0018.8ebc7a4a.jpg";